import { UserState } from './types'

export const getOnboardingData = (slice: UserState) => slice.onboardingData

export const getCreateUserStatus = (slice: UserState) => slice.userData.status

export const getUserData = (slice: UserState) => slice.userData

export const getUserMetrics = (slice: UserState) => slice.metrics

export const getStripeCustomerData = (slice: UserState) => slice.stripeCustomerData
